export const BUCKET_URL = 'https://storage.googleapis.com/bucket-de-arquivos-prod-open' as const
